/* eslint-disable prettier/prettier */
/* eslint-disable no-undef */
; (() => {
  const button = document.getElementById('back-to-top');
  if (!button) {
    console.log("Back to top button hasn't been added");
    return;
  }

  const handleScrollTop = () => {
    window.scrollTo(0, 0);
  };

  button.addEventListener('click', () => handleScrollTop());

})();
